export default "__VITE_ASSET__CbaY7aQs__"